import { getState, UpdateState } from "./function";
import React from "react";
import $ from "jquery";

export const addSelected = (input, elem, pop = "") => {
  if(input.target.value && input.target.value != ""){
    $(elem).addClass('selected');
  }
  else{
    $(elem).removeClass('selected');
  }
}

export const addSelectedX = (elem) => {
  if($(elem).find('option:selected').val() && $(elem).find('option:selected').val().length > 0 && $(elem).find('option:selected').val() != ""){
    $(elem).addClass('selected');
  }
  else{
    $(elem).removeClass('selected');
  }
}

export const UpdateInput = (elem, target, input) => {
let value = input.target.value.replace(/[^0-9\.]/g,'');
UpdateState(elem, target, value);
$(input.target).attr('data-v', value);
}

export const UpdateSelectX = (elem, target, input) => {
  if(target != "" && target != undefined && target != null){
  UpdateState(elem, target, input);
  }
  }

export const Input = (props) => {
   if(props.inputValue != "" && props.inputValue != undefined && props.inputValue != null && props.inputValue != false && getState(props.self, props.inputStateX) != 1){
    //UpdateState(props.self, props.inputState, props.inputValue);
    UpdateState(props.self, props.inputState+"_x", '1');
  }
    return (
      <>
  <div className={props.wrapperClass} hidden={props.inputHidden}>
      <input data-v="" type={props.inputType} className={props.inputClass} placeholder={props.inputPlaceholder} 
      value={getState(props.self, props.inputState)}
      defaultValue={getState(props.self, props.inputState)}
      onChange={(input) => UpdateState(props.self, props.inputState, input.target.value) }
      onBlur={(input) => UpdateState(props.self, props.inputState, input.target.value) }
      onInput={(input) => UpdateState(props.self, props.inputState, input.target.value) }
      maxlength={props.inputMaxLength} required={props.inputRequired} readonly={(props.inputReadOnly > 0 || props.inputReadOnly == true || props.inputReadOnly == 'readonly') ? 'true' : false} accept={props.inputAccept}/>
         <label for={props.inputLabel}>{props.inputLabel}</label>
        </div>
      </>
    );
}

export const File = (props) => {
    return (
      <>
  <div className={props.wrapperClass} hidden={props.inputHidden}>
      <input type="file" className={props.inputClass} placeholder={props.inputPlaceholder} 
      onChange={(input) => UpdateState(props.self, props.inputState, input.target.files[0]) } required={props.inputRequired} accept={props.inputAccept}/>
        </div>
      </>
    );
}

export const Select = (props) => {

  if(props.inputSelected && props.inputSelected != ""){
    addSelectedX(props.selectedClass);
    //UpdateState(props.self, props.inputState, props.inputSelected);
  }

    return (
      <>
  <div className={props.wrapperClass} hidden={props.inputHidden}>
      <select className={props.inputClass} 
      readonly={(props.inputReadOnly > 0 || props.inputReadOnly == true || props.inputReadOnly == 'readonly') ? 'true' : false}
      disabled={(props.inputReadOnly > 0 || props.inputReadOnly == true) ? 'true' : false}
      onChange={(input) => { UpdateState(props.self, props.inputState, input.target.value); addSelected(input, props.selectedClass); UpdateSelectX(props.self, props.inputStateX ? props.inputStateX : '', input.target.value); } } required={props.inputRequired}>
          <option value="">{props.inputPlaceholder}</option>
     {props.inputOptions?.length > 0 ?
     (props.inputOptions?.map((option, i) => {
      return <option key={i} value={option.value} selected={props.inputSelected && props.inputSelected != "" && option.value == props.inputSelected} disabled={(props.inputDisabledAtValue && props.inputDisabledAtValue != "" && option.value == props.inputDisabledAtValue) || (props.inputReadOnly > 0 || props.inputReadOnly == true)}>{option.text}</option>
     }))  : <option value=""> -- No Data Available -- </option>};
          </select>
        </div>
      </>
    );
}

export const Textarea = (props) => {
  return (
    <>
<div className={props.wrapperClass} hidden={props.inputHidden}>
    <textarea rows={props.inputRows} cols={props.inputCols} className={props.inputClass} placeholder={props.inputPlaceholder} 
    defaultValue={props.inputValue}
    onChange={(input) => UpdateState(props.self, props.inputState, input.target.value) } maxlength={props.inputMaxLength} required={props.inputRequired} readonly={(props.inputReadOnly > 0 || props.inputReadOnly == true || props.inputReadOnly == 'readonly') ? 'true' : false} />
      <label for={props.inputLabel}>{props.inputLabel}</label>
      </div>
    </>
  );
}